import {SHOW_POPUP_WITH_INPUT, HIDE_POPUP_WITH_INPUT} from '@/store/mutation-types'

export default {
	computed: {
		hasPopupWithInput() {
			return this.$store.getters.hasPopupWithInput;
		},
		getPopupWithInputMessage() {
			return this.$store.getters.getPopupWithInputMessage;
		},
		getPopupWithInputButtonText() {
			return this.$store.getters.getPopupWithInputSubmitButtonText;
		}
	},
	methods: {
		showPopupWithInput(action, message, buttonText, defaultInputValue, data) {
			this.$store.commit(SHOW_POPUP_WITH_INPUT, {action, message, buttonText, defaultInputValue, data})
		},
		hidePopupWithInput() {
			this.$store.commit(HIDE_POPUP_WITH_INPUT)
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/mixins/popup-with-input.js